import getConfig from 'next/config'
import { headers } from '../lib/fetch'

const {
  publicRuntimeConfig: { LOYALTY_API },
} = getConfig()

const loyaltyFetcher = async (endpoint, params) => {
  return fetch(`${LOYALTY_API}/${endpoint}`, {
    ...params,
  })
    .then(data => {
      if (!data.ok) {
        throw data
      }
      return data.json()
    })
    .catch(error => {
      if (error instanceof Error) {
        throw Error('Something went wrong. Try again')
      }

      return error.json().then(errorJson => {
        throw Error(errorJson.message)
      })
    })
}

export const get = (endpoint, params) => {
  return loyaltyFetcher(endpoint, {
    method: 'get',
    ...params,
  })
}

export const post = (endpoint, params) => {
  return loyaltyFetcher(endpoint, {
    method: 'post',
    ...params,
  })
}

export const getDigitalClubAccount = ctx => {
  return loyaltyFetcher('memberships?programmeId=2', {
    method: 'get',
    headers: headers(ctx, true),
  }).then(data => (data[0] ? data[0] : {}))
}

export const cancelMembership = (id, ctx) => {
  return loyaltyFetcher(`memberships/${id}/cancel`, {
    method: 'put',
    headers: headers(ctx, true),
  })
}

export const getDcFreeTrialEligibility = ({ ctx, id }) => {
  return loyaltyFetcher(`freetrial/packages/${id}`, {
    method: 'get',
    headers: headers(ctx, true),
  })
}
